<app-exams-calendar
  [mobileMode]="true"
  [showCurrentDayButton]="true"
  [showMobileFilters]="true"
  [filtersLabel]="widgetData.filtersTitle"
  [currentDayButtonLabel]="widgetData.btnSelectTodayText"
  [disableDetailsShowing]="true"
  [studentCalendarFilters]="widgetData.studentCalendarFilters"
  [timeRange]="widgetData.timeRange"
  (eventsLoded)="calendarEventsLoded($event)"
  (dayItemClicked)="dayItemClickedHandler($event)"
  (loadingStateChanged)="loadingStateChangedHandler($event)"
  class="month-calendar"
/>

<ng-container>
  <div class="month-events-wrap"> 
    <app-month-events [isLoading]="isLoading" [monthEvents]="monthEvents" [studentCalendarFilters]="widgetData.studentCalendarFilters" 
      [notificationHeader]="widgetData.lessonsNotificationsPopupHeaderText" [submissionLabel]="widgetData.assignmentSummbissionLabel" [atHourLabel]="widgetData.assignmentAtHourText"/>
  </div>
</ng-container>
